export default "__VITE_ASSET__CtuQf5mz__"